import React, { useEffect, useState } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [imageCredits, setImageCredits] = useState(null);
  const [isCreditsOpen, setIsCreditsOpen] = useState(false);

  useEffect(() => {
    const fetchCredits = async () => {
      try {
        const res = await fetch('/assets/image-credits.json');
        if (!res.ok) return;
        const data = await res.json();
        setImageCredits(data);
      } catch (e) {
        // ignore if file not present
      }
    };
    fetchCredits();
  }, []);

  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">Falak al Madina</h3>
            <p className="text-gray-400 mb-4">
              Your trusted partner for quality heavy machinery auto spare parts.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('home').scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-blue-400 transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-blue-400 transition-colors"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('brands').scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-blue-400 transition-colors"
                >
                  Brands
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-blue-400 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Phone size={18} className="text-blue-400" />
                <a href="tel:+971586712077" className="text-gray-400 hover:text-blue-400 underline transition-colors">
                  +971 58 671 2077
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={18} className="text-blue-400" />
                <span>info@famparts.com</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={18} className="text-blue-400 mt-1" />
                <span>Industrial Area 2, Sharjah, United Arab Emirates</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Image credits link (opens modal) */}
        {imageCredits && imageCredits.length > 0 && (
          <div className="mt-6 mb-6 text-center">
            <button
              onClick={() => setIsCreditsOpen(true)}
              className="text-sm text-gray-400 hover:text-blue-400 underline transition-colors"
            >
              Image credits
            </button>
          </div>
        )}

        {/* Credits Modal */}
        {isCreditsOpen && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
            onClick={() => setIsCreditsOpen(false)}
            role="dialog"
            aria-modal="true"
          >
            <div
              className="bg-white rounded-lg max-w-2xl w-full overflow-auto shadow-xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between px-6 py-4 border-b">
                <h3 className="text-lg font-semibold text-gray-900">Image Credits</h3>
                <button
                  onClick={() => setIsCreditsOpen(false)}
                  className="text-gray-500 hover:text-gray-900"
                  aria-label="Close credits"
                >
                  ×
                </button>
              </div>

              <div className="p-6 text-sm text-gray-700">
                <p className="mb-4 text-gray-600">The following images used on the site:</p>
                <ul className="space-y-3">
                  {imageCredits.map((c, i) => (
                    <li key={i} className="break-words">
                      <span className="font-medium text-gray-800">{c.file}:</span>{' '}
                      {c.source ? (
                        <a href={c.source} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                          {c.credit}
                        </a>
                      ) : (
                        <span>{c.credit}</span>
                      )}
                    </li>
                  ))}
                </ul>
                <p className="mt-6 text-xs text-gray-500">To update attributions edit <strong>public/assets/image-credits.json</strong>.</p>
              </div>

              <div className="px-6 py-4 border-t flex justify-end">
                <button
                  onClick={() => setIsCreditsOpen(false)}
                  className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200 text-sm"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400">
            © {currentYear} Falak al Madina Auto Spare Parts. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;